// Words — pick a random `[flic, infiltre]` pair from the configured pool.

import type { Locale } from '../i18n/locale';
import { CATEGORIES, type Category, type WordPair } from './categories';

/**
 * Pick a random word pair from the union of every selected category for the given locale.
 *
 * @param locale - Locale to draw words from.
 * @param categories - Selected categories. Pool is the flat union across all of them.
 * @param rand - 0-1 random source (inject `ctx.rng.next` from the engine).
 * @returns A `[flic, infiltre]` tuple.
 * @throws If the resulting pool is empty (no categories supplied or empty content).
 */
export const pickWordPair = (
  locale: Locale,
  categories: readonly Category[],
  rand: () => number,
): WordPair => {
  const pool = categories.flatMap((c) => CATEGORIES[c][locale]);
  if (pool.length === 0) throw new Error('pickWordPair: empty pool');
  return pool[Math.floor(rand() * pool.length)]!;
};
